module.exports = __webpack_public_path__ + "img/124f01bbd7a3edc4b48b2da843da23eb.png";